<template>
    <div>
        <v-card>
            <v-toolbar
                flat
                color="primary"
                dark
                dense
            >
                <v-icon left>mdi-briefcase</v-icon>
                  Case Types
                <v-spacer />
                <v-btn
                    round
                    color="success"
                    :to="{name: 'OrgSelectedCaseType', params: {id: 'new'}}"
                >
                    <v-icon left>add</v-icon>
                    New Case Type
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout
                    row
                    wrap
                >
                    <v-flex
                        sm3
                        style="display: flex;flex-direction: column;"
                    >
                        <v-text-field
                          v-model="search"
                          box
                          hide-details
                          :loading="loading"
                          label="Search Types"
                          clearable
                          style="flex-grow: 0;"
                        />
                        <v-list
                            three-line
                            style="background: rgba(0,0,0,.03);border-radius: 5px;flex-grow: 1;"
                        >
                            <v-list-tile
                                v-for="casetype in ct"
                                :key="casetype.id"
                                :to="{name: 'OrgSelectedCaseType', params: {id: casetype.id}}"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="casetype.name" />
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                :disabled="!canPrev"
                                icon
                                @click="goPage(-1)"
                            >
                                <
                            </v-btn>
                            &nbsp;
                            {{page * 10 - 9}}
                            -
                            {{page * 10 > total ? total : page * 10}}
                             of 
                            {{total}}
                            &nbsp;
                            <v-btn
                                :disabled="!canNext"
                                icon
                                @click="goPage(1)"
                            >
                                >
                            </v-btn>
                            <v-spacer />
                        </v-card-actions>
                    </v-flex>
                    <v-flex
                        sm9
                    >
                        <v-card
                            v-if="focusCt || loadingCase"  
                            style="margin: 0 10px 0 10px;"
                        >
                            <v-toolbar
                                dense
                                flat
                            >
                                <v-spacer />
                                <v-btn
                                    small
                                    @click="$router.replace({name: 'OrgCaseType'})"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    :disabled="!changed || saving || !canSave"
                                    color="primary"
                                    small
                                    @click="saveCaseType()"
                                >
                                    Save Changes
                                </v-btn>
                            </v-toolbar>
  
                            <v-card-text
                                v-show="loadingCase"
                            >
                                <div
                                    style="padding: 25px;margin:auto"
                                >
                                    <v-progress-linear
                                        indeterminate
                                        query
                                    />
                                </div>
                            </v-card-text>
                            <v-card-text
                                v-show="!loadingCase"
                            >
                                <v-text-field
                                  v-model="focusCt.name"
                                  label="Name"
                                />
                                <v-text-field
                                  v-model="focusCt.description"
                                  label="Description"
                                />

                                <div
                                    style="display: flex;align-items: center;"
                                >
                                    <img
                                        v-if="focusCt.icon"
                                        :key="focusCt.icon"
                                        :src="getIconPath(focusCt.id)"
                                        style="max-width:50px;max-height:50px;margin:10px;"
                                    />
                                    <v-flex  d-inline-flex pa-1 style="text-align:center">
                                        <label for="image-upload" class="custom-image-upload">
                                            Case Type Image Upload
                                        </label>
                                        <input id="image-upload" type="file" ref="caseTypeFile" style="display: none;" v-on:change="handleFileUploads()" />
                                    </v-flex>
                                    <v-flex d-inline-flex>
                                        <div v-if="isValidImage" class="filevalidity">
                                            <v-icon style="color:green">
                                                mdi-check
                                            </v-icon>
                                            <span> File has been uploaded</span>
                                        </div>
                                        <div v-else-if="!isValidImage && isValidImage !== null" class="filevalidity">
                                            <v-icon style="color:red">
                                                mdi-exclamation
                                            </v-icon>
                                            <span> File is not compatible, please upload a PNG, JPEG, or GIF</span>
                                        </div>
                                        <div v-else-if="focusCt.icon" class="filevalidity">
                                            <v-icon style="color:green">
                                                mdi-check
                                            </v-icon>
                                            <span>File previously uploaded</span>
                                        </div>
                                    </v-flex>
                                    <br />
                                    <v-flex sm2 style="text-align:center">
                                        <small>
                                            Recommended Size: 480px x 480px
                                        </small>
                                    </v-flex>
                                </div>
                            </v-card-text>
                        </v-card>
                      <div
                        v-else
                        style="display:flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;min-height: 600px;width: 100%;margin:auto;"
                      >
                        <div
                          style="text-align:center;font-size: 20px;font-weight: 300;"
                        >
                          <b>Select a Case Type to edit or create a new Case Type</b>
                        </div>
                        <div
                          style="display: flex;padding: 10px;background: #ECEFF1;border-radius: 10px;border: 1px solid #78909C;margin-top: 25px;opacity:0.7;max-width:500px;margin: 20px;"
                        >
                          <v-icon
                            left
                            size="32"
                            style="align-self: flex-start;"
                          >
                            mdi-information
                          </v-icon>
                          <div>
                            <div
                              style="font-size: 16px;font-weight: 700;"
                            >
                              About Cases &amp; Case Types
                            </div>
                            <div
                              style="font-size: 12px;"
                            >
                              Cases organize related Forms into one container, allowing for cleaner separation and organization of Forms of different parties or Case Types within a single Contact.<br /><br />
                              Case Types allow you to name these groups of Forms with a common label, and set an icon that is displayed to Contacts.
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
  </template>
    
  
  <script>
  import api from '@/api'
  
  export default {
      data () {
          return {
              ct: null,
              focusCt: null,
              changed: false,
              loading: false,
              loadingCase: false,
              saving: false,
              search: null,
              page: 1,
              canNext: false,
              canPrev: false,
              total: 0,
              isValidImage: null,
            nonCompatibleImageTypes: [
                'tiff',
                'svg+xml'
            ],
          }
      },
      created () {
          if (this.$route.params.id) {
              this.getCaseType(this.$route.params.id)
          }
          this.getCaseTypes()
          this.documentTitle('Case Types')
      },
      methods: {
        handleFileUploads() {
            this.focusCt.logo = this.$refs.caseTypeFile.files[0]
            this.isValidImage = this.isFileAnImage(this.focusCt.logo)
            if (this.isValidImage)
                this.changed = true
        },
        isFileAnImage(file) {
            return file.type.split('/')[0] === 'image' && !this.nonCompatibleImageTypes.includes(file.type.split('/')[1])
        },
            getIconPath (id) {
                return api.cases.casetype.icon(id)
            },
          goPage (int) {
            if (int < 0 && this.canPrev || int > 0 && this.canNext) {
                this.page = this.page + int
                this.getCaseTypes(this.search)
            }
          },
          getCaseTypes (search = null) {
              this.loading = true
              api.cases.casetype.list({
                search: search, 
                pageNum: this.page
              })
                  .then((data) => {
                      this.total = data['count']
                      this.canNext = data['next_page'] !== null
                      this.canPrev = data['previous_page'] !== null
                      this.ct = data['results']
                      this.loading = false
                  })
          },
          getCaseType (id) {
            this.loadingCase = true
              api.cases.casetype.get(id)
                  .then((data) => {
                      this.focusCt = data
                      this.changed = false
                  })
          },
          saveCaseType () { 
            this.changed = false
            this.saving = true
            const data = new FormData()
            data.append("name", this.focusCt.name)
            data.append("description", this.focusCt.description)
            if(this.focusCt.logo){
                data.append("icon", this.focusCt.logo)
            }
            if(this.focusCt.id){
                data.append("id", this.$route.params.id)
            }
            api.cases.casetype.save(data)
            .then(casetype => {
                if ('id' in this.focusCt) {
                    this.focusCt = casetype
                } else {
                    this.ct.push(casetype)
                    this.$router.replace({name: 'OrgSelectedCaseType', params: {id: casetype.id}})
                }
            })
            .finally(() => {
              this.saving = false
              this.getCaseTypes(this.search)
              this.$forceUpdate()
            })
          }
      },
      async beforeRouteUpdate(to, from, next) {
          if (this.changed) {
              const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
              if (!answer)
                  return false
          }
          next()
      },
      beforeRouteLeave (to, from, next) {
          if (this.changed) {
              const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
              if (!answer)
                  return false
          }
          next()
      },
        computed:{
            canSave(){
                return this.isValidName && ((this.isValidImage || this.focusCt.icon) || this.focusCt.icon == null)
            },
            isValidName(){
                return this.focusCt.name !== '' && this.focusCt.name != null
            }
        },
      watch: {   
          $route (to, from) {
              if (to.params.id == "new") {
                this.loadingCase = true
                this.focusCt = {
                  name: 'A New Case Type',
                  description: ''
                }
                this.changed = false
                this.loadingCase = false
              }
              else if (to.params.id) {
                  this.getCaseType(to.params.id)
              } 
              else {
                  this.focusCt = null
              } 
          },
          search () {
              this.page = 1
              this.getCaseTypes(this.search)
          },
          focusCt: {
              handler(newValue, oldValue) {
                  if (this.loadingCase || !this.$route.params.id) {
                      this.changed = false
                      this.loadingCase = false
                  }
                  else {
                    this.changed = true
                  }
                    
              },
              deep: true,
              flush: 'post'
          }
      }
  }
  </script>
    
<style>
    
.filevalidity {
    text-align: left;
    display: inline-block;
    align-self: flex-end;
}

.custom-image-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 10px 12px;
    cursor: pointer;
    color: white;
    background-color: #2196f3;
    letter-spacing: .1em;
}
</style>
    